<div>
	<h2>{{'nav.disable_external_rtc' | translate}}</h2>
	<div class="d-flex justify-content-end my-3" *ngIf="usersService.hasAccessPermission(null, 'noc', 'write')">
		<button class="btn btn-primary btn-sm mx-2" [disabled]="!selectedDevices.length"
			(click)="restartDeviceConfirm.show()">
			{{'devices.enable_external_rtc' | translate}}
		</button>
	</div>
	<sct-custom-table
		[columnsConfig]="columnConfig"
		[data]="tableData"
		[config]="tableConfig"
		(updateSelectedRows)="updateSelectedDevices($event)"
	></sct-custom-table>
</div>

<app-modal #restartDeviceConfirm [title]="'devices.restart_required' | translate">
	<p>
		{{'devices.restart_device_confirm_message'| translate }}
	</p>
	<ul>
		<li>{{'devices.disable_external_rtc' | translate}}</li>
	</ul>
</app-modal>
